import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Sun, Shield, Bed, Bath, Square, ShoppingBag, Mountain, GraduationCap, TreePine, TrendingUp, Home } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
import { ListingsComingSoon } from '../components/ListingsComingSoon';
const placeholderListings = [{
  id: 1,
  price: '$520,000',
  address: '7834 Mesa Peak Dr',
  area: 'Mountains Edge',
  beds: 4,
  baths: 3,
  sqft: '2,300',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2940&auto=format&fit=crop'
}, {
  id: 2,
  price: '$445,000',
  address: '9012 Blue Diamond Rd',
  area: 'Southwest',
  beds: 3,
  baths: 2,
  sqft: '1,800',
  image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?q=80&w=2792&auto=format&fit=crop'
}, {
  id: 3,
  price: '$675,000',
  address: '2145 Cactus Ridge Way',
  area: 'Rhodes Ranch',
  beds: 4,
  baths: 3.5,
  sqft: '2,900',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop'
}];
export function SouthwestPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-white" data-id="element-778">
      <section className="relative h-[70vh] min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-779">
        <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1600585154526-990dced4db0d?q=80&w=2787&auto=format&fit=crop")'
      }} data-id="element-780">
          <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply" data-id="element-781"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-transparent to-charcoal/80" data-id="element-782"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-783">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1
        }} data-id="element-784">
            <span className="text-gold uppercase tracking-[0.3em] text-sm font-medium mb-6 block" data-id="element-785">
              Community Spotlight
            </span>
            <h1 className="text-5xl md:text-7xl text-white font-serif mb-6 leading-tight" data-id="element-786">
              Southwest Las Vegas
            </h1>
            <p className="text-lg md:text-xl text-white/90 font-light max-w-2xl mx-auto" data-id="element-787">
              One of the fastest-growing areas in the valley with modern
              developments and stunning mountain views.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 px-6 bg-white" data-id="element-788">
        <div className="max-w-7xl mx-auto" data-id="element-789">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-790">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-791">
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-792">
                The Future of{' '}
                <span className="italic text-gold" data-id="element-793">Las Vegas Living</span>
              </h2>
              <div className="space-y-4 text-charcoal-light font-light leading-relaxed text-lg" data-id="element-794">
                <p data-id="element-795">
                  Southwest Las Vegas has exploded in growth over the past
                  decade, transforming from open desert into one of the most
                  exciting residential areas in the valley. With brand-new
                  master-planned communities, modern architecture, and some of
                  the best mountain views in Vegas, it's attracting buyers who
                  want new construction at exceptional value.
                </p>
                <p data-id="element-796">
                  The area is anchored by communities like Mountain's Edge,
                  Rhodes Ranch, and the rapidly developing areas along Blue
                  Diamond Road. Homes range from affordable $350K new builds to
                  stunning $800K+ custom homes with panoramic views of the
                  Spring Mountains.
                </p>
                <p data-id="element-797">
                  Southwest Las Vegas also benefits from proximity to the new
                  Raiders Allegiant Stadium, the Las Vegas Strip, and easy
                  freeway access via the 215 Beltway and I-15.
                </p>
              </div>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="grid grid-cols-2 gap-6" data-id="element-798">
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-799">
                <TrendingUp className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-800" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-801">#1</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-802">
                  Growth Area
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-803">
                <Home className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-804" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-805">New</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-806">
                  Construction
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-807">
                <Mountain className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-808" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-809">Epic</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-810">
                  Mountain Views
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-811">
                <MapPin className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-812" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-813">15m</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-814">
                  To The Strip
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Communities */}
      <section className="py-24 bg-warmGray px-6 border-y border-warmGray-dark" data-id="element-815">
        <div className="max-w-7xl mx-auto" data-id="element-816">
          <div className="text-center mb-16" data-id="element-817">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-818">
              Master-Planned Living
            </span>
            <h2 className="text-4xl font-serif text-charcoal" data-id="element-819">
              Top Communities
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-820">
            {[{
            name: "Mountain's Edge",
            price: '$380K - $650K',
            desc: "One of Vegas's most popular master-planned communities with 1,000+ acres of parks, trails, and a stunning exploration peak trail system.",
            img: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2940&auto=format&fit=crop'
          }, {
            name: 'Rhodes Ranch',
            price: '$400K - $800K',
            desc: 'A guard-gated golf course community featuring a Ted Robinson-designed course, resort-style pools, and elegant homes.',
            img: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop'
          }, {
            name: 'Inspirada',
            price: '$350K - $550K',
            desc: 'A vibrant newer community in the southwest corridor with modern homes, community pools, and excellent parks.',
            img: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?q=80&w=2792&auto=format&fit=crop'
          }].map((n, idx) => <motion.div key={n.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-white p-6 shadow-sm border border-warmGray-dark" data-id="element-821">
                <img src={n.img} alt={n.name} className="w-full h-48 object-cover mb-4" data-id="element-822" />
                <div className="flex justify-between items-start mb-3" data-id="element-823">
                  <h3 className="text-xl font-serif text-charcoal" data-id="element-824">{n.name}</h3>
                  <span className="text-xs font-medium text-gold bg-gold/10 px-2 py-1 rounded whitespace-nowrap" data-id="element-825">
                    {n.price}
                  </span>
                </div>
                <p className="text-charcoal-light font-light text-sm leading-relaxed" data-id="element-826">
                  {n.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Nearby */}
      <section className="py-24 px-6 bg-white" data-id="element-827">
        <div className="max-w-7xl mx-auto" data-id="element-828">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-829">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-830">
              Life in the Southwest
            </span>
            <h2 className="text-4xl font-serif text-charcoal" data-id="element-831">What's Nearby</h2>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-832">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="group" data-id="element-833">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-834">
                <img src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2842&auto=format&fit=crop" alt="Red Rock" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-835" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-836">
                Red Rock Canyon
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-837">
                Just minutes from Southwest Las Vegas, offering world-class
                hiking, rock climbing, and the iconic 13-mile scenic drive.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="group" data-id="element-838">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-839">
                <img src="https://images.unsplash.com/photo-1540747913346-19e32dc3e97e?q=80&w=2905&auto=format&fit=crop" alt="Stadium" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-840" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-841">
                Allegiant Stadium
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-842">
                Home of the Las Vegas Raiders and host to major concerts and
                events, just a short drive via I-15.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="group" data-id="element-843">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-844">
                <img src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?q=80&w=2940&auto=format&fit=crop" alt="Shopping" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-845" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-846">
                Galleria at Sunset
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-847">
                Major shopping destination with department stores, dining, and
                entertainment options for the whole family.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <ListingsComingSoon area="Southwest Las Vegas" data-id="element-848" />

      <ContactCTA data-id="element-849" />
    </main>;
}